module.exports = __webpack_public_path__ + "img/br.8207088c.svg";